module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title-wrapper"
  }, [_c('div', {
    staticClass: "button-wrapper"
  }, [_vm._t("new-button")], 2), _c('h1', {
    staticClass: "primary-title"
  }, [_vm._v(_vm._s(_vm.title))]), (_vm.subTitle) ? _c('h4', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.subTitle))]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-777d8892", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-777d8892"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/layout/pageTitle/pageTitle.pug
// module id = 1441
// module chunks = 0